export const MAX_XLSX_BYTES = 64 * 1024 * 1024;
export const XLSX_MIME = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
export const NOTIFICATION_FILE_ROUTE = '/notifications/:organizationId/:userNotificationId/file';
export const isNotificationFilePath = value => /^\/notifications\/[1-9][0-9]*\/[1-9][0-9]*\/file\/?$/.test(value);
const validId = value => /^[1-9][0-9]*$/.test(String(value)) && Number.isSafeInteger(Number(value));

export function fileEndpoint(domain, organizationId, userNotificationId) {
	if (!validId(organizationId) || !validId(userNotificationId)) throw new Error('Archivo no disponible.');
	const base = new URL(domain);
	if ((base.protocol !== 'https:' && !(base.protocol === 'http:' && ['localhost', '127.0.0.1'].includes(base.hostname))) ||
		base.username || base.password || base.search || base.hash) throw new Error('Descarga no disponible.');
	return base.href.replace(/\/$/, '') + `/user_notifications/${organizationId}/${userNotificationId}/file`;
}

export async function downloadSubscriptionFile({ domain, organizationId, userNotificationId, headers, signal,
	fetchImpl = fetch, deadlineMs = 125000 }) {
	const url = fileEndpoint(domain, organizationId, userNotificationId);
	const controller = new AbortController();
	const abort = () => controller.abort();
	if (signal?.aborted) controller.abort();
	signal?.addEventListener('abort', abort);
	const timer = setTimeout(abort, deadlineMs);
	let reader;
	try {
		const response = await fetchImpl(url, { headers, signal: controller.signal, credentials: 'omit', redirect: 'error' });
		if (response.status === 401) throw new Error('Inicie sesión para descargar el archivo.');
		if (!response.ok || response.redirected || response.headers.get('content-type')?.split(';')[0] !== XLSX_MIME)
			throw new Error('Archivo no disponible para este usuario y organización. Seleccione la organización del informe y vuelva a abrir el enlace.');
		const length = Number(response.headers.get('content-length'));
		if (!Number.isSafeInteger(length) || length < 4 || length > MAX_XLSX_BYTES || !response.body?.getReader)
			throw new Error('Archivo no disponible.');
		reader = response.body.getReader();
		const chunks = [];
		let count = 0, prefix = [];
		for (;;) {
			const result = await reader.read();
			if (controller.signal.aborted) throw new Error('Descarga cancelada.');
			if (result.done) break;
			count += result.value.length;
			if (count > length || count > MAX_XLSX_BYTES) throw new Error('Archivo no disponible.');
			for (const byte of result.value.slice(0, 4 - prefix.length)) prefix.push(byte);
			if (prefix.length === 4 && prefix.join(',') !== '80,75,3,4') throw new Error('Archivo no disponible.');
			chunks.push(result.value);
		}
		if (count !== length || prefix.length !== 4) throw new Error('Archivo incompleto.');
		return new Blob(chunks, { type: XLSX_MIME });
	} finally {
		clearTimeout(timer);
		signal?.removeEventListener('abort', abort);
		controller.abort();
		if (reader) await reader.cancel().catch(() => {});
	}
}
